import React from "react";

const RoleLabel = ({ role_type=1 }) => {
  const getRoleLabel = (type) => {
    switch (type) {
      case 3:
        return "Expert";
      case 4:
        return "Company";
      default:
        return "User";
    }
  };

  return getRoleLabel(role_type)
};

export default RoleLabel;
